import React from 'react';
import {useDispatch} from 'react-redux';
import {Route, Routes} from 'react-router-dom';

import * as paths from 'paths';
import {setPasswordResetState} from 'modules/authentication/actions';
import {passwordResetStates} from 'modules/authentication/constants';

import Login from 'components/Authentication/Login';
import PasswordReset from 'components/Authentication/PasswordReset';
import PlaceholderLayout from './PlaceholderLayout';

export default function AuthenticationLayout() {

    const dispatch = useDispatch();

    const resetId = localStorage.getItem('passwordResetId');
    if (resetId) {
        dispatch(setPasswordResetState(passwordResetStates.ENTER_CODE));
    }

    return <Routes>
        <Route index element={<Login/>}/>
        <Route path={paths.FORGOTTEN_PASSWORD} element={<PasswordReset/>}/>
        <Route path={paths.OAUTH2_REDIRECT} element={<PlaceholderLayout/>}/>
    </Routes>;

}